import ProductCategoryStep from './CategoryStep';

export default ProductCategoryStep;
